import constants from "@/constants";

const campaignSteps = [
  { index: 1, name: "Seu anúncio", icon: "mdi-file-document-outline" },
  { index: 2, name: "Formatos", icon: "mdi-monitor-dashboard" },
  { index: 3, name: "Cobertura", icon: "mdi-map-marker-radius" },
  { index: 4, name: "Investimento", icon: "mdi-currency-usd" },
  { index: 5, name: "Resumo", icon: "mdi-movie-play-outline" },
  { index: 6, name: "Pagamento", icon: "mdi-credit-card-outline" }
];

const ObjetivesList = [
  {
    id: "1",
    icon: "mdi-star-circle-outline",
    text: "Reconhecimento de Marca"
  },
  { id: "2", icon: "mdi-earth", text: "Tráfego Online" },
  {
    id: "3",
    icon: "mdi-cart-outline",
    text: "Venda de Produtos ou Serviços"
  }
];

const timesList = [
  { id: "manha", text: "Manhã" },
  { id: "tarde", text: "Tarde" },
  { id: "noite", text: "Noite" },
  { id: "madrugada", text: "Madrugada" }
];

const daysList = [
  { id: "seg", text: "Segunda" },
  { id: "ter", text: "Terça" },
  { id: "qua", text: "Quarta" },
  { id: "qui", text: "Quinta" },
  { id: "sex", text: "Sexta" },
  { id: "sab", text: "Sábado" },
  { id: "dom", text: "Domingo" }
];

const durationsList = [
  { id: "15", text: "15 segundos" },
  { id: "30", text: "30 segundos" },
  { id: "45", text: "45 segundos" },
  { id: "60", text: "60 segundos" }
];

const formatsList = [
  { id: "1", text: "Pre-Roll 15s /s Skip" },
  { id: "3", text: "Pre-Roll 30s" },
  { id: "2", text: "Mid-Roll 30s" },
  { id: "4", text: "Bumper Ads 6s" }
];

const genderList = [
  { id: "male", name: "Homens" },
  { id: "female", name: "Mulheres" }
];

const socialClassList = [
  { id: "A", name: "A" },
  { id: "B", name: "B" },
  { id: "C", name: "C" },
  { id: "D", name: "D" },
  { id: "E", name: "E" }
];

const statusList = Object.keys(constants.STATUS_TEXT).map(str =>
  str.toLowerCase()
);

/*
APPROVED_PAYMENT: "Pagamento aprovado",
AUTHORIZED_PAYMENT: "Pagamento autorizado",
AWAITING_MIDIA: "Aguardando envio mídia",
CANCELLED_PAYMENT: "Pagamento cancelado",
CHARGED_BACK_PAYMENT: "Pagamento reembolsado",
DONE: "Encerrado"
DRAFT: "Rascunho",
IN_ANALYSIS_PAYMENT: "Pagamento em análise",
IN_MEDIATION_PAYMENT: "Pagamento mediado",
IN_PROCESS_PAYMENT: "Pagamento em processo",
PENDING_PAYMENT: "Pagamento pendente",
REFUNDED_PAYMENT: "Pagamento reembolsado",
REJECTED_PAYMENT: "Pagamento rejeitado",
SETTLED_PAYMENT: "Pagamento liquidado",
WAITING_PAYMENT: "Pagamento em processo",
*/

/*
ONAPPROVAL: send the movie to internal Stayfilm curation team.
EXTERNAL_APPROVED: the movie was approved by client. It will be sent to voiceover system to be spoken.
EXTERNAL_REJECTED: the movie was rejected by client and will not be used anymore.
VOICEOVER_APPROVED: the client approved the video with voiceover. Now, the client can show the video to its consumer.
VOICEOVER_REJECTED: the voiceover was rejected and will be done again.
VOICEOVER_DONE: ??????
FINAL_APPROVED: the final video was approved and now it will be registered on ANCINE and the final video in high quality will be produced.
FINAL_REJECTED: the final video was rejected and will be discarded.
SAVED: the movie is a final approved version and is not necessary send it to be registered on ANCINE.
*/

const statusGroupEditable = [
  "DRAFT",
  "REJECTED_PAYMENT",
  "CANCELLED_PAYMENT",
  "REFUNDED_PAYMENT",
  "CHARGED_BACK_PAYMENT"
];

const statusGroup: StatusGroup = {
  draft: { name: "Anúncios em Rascunho", indexes: ["DRAFT"] },
  payment: {
    name: "Status de pagamentos",
    indexes: [
      "CANCELLED_PAYMENT",
      "CHARGED_BACK_PAYMENT",
      "IN_ANALYSIS_PAYMENT",
      "IN_MEDIATION_PAYMENT",
      "IN_PROCESS_PAYMENT",
      "PENDING_PAYMENT",
      "REFUNDED_PAYMENT",
      "REJECTED_PAYMENT",
      "WAITING_PAYMENT"
    ],
    alerts: [
      "CANCELLED_PAYMENT",
      "CHARGED_BACK_PAYMENT",
      "REFUNDED_PAYMENT",
      "REJECTED_PAYMENT",
      "PENDING_PAYMENT",
      "WAITING_PAYMENT",
      "IN_ANALYSIS_PAYMENT"
    ]
  },
  progress: {
    name: "Anúncios em Andamento",
    indexes: [
      "AUTHORIZED_PAYMENT",
      "AWAITING_MIDIA",
      "APPROVED_PAYMENT",
      "SETTLED_PAYMENT",
      "ONAPPROVAL",
      "EXTERNAL_REJECTED",
      "INTERNAL_REJECTED",
      "INTERNAL_APPROVED",
      "MIDIA_PROGRESS",
      "VOICEOVER_DONE",
      "MIDIA_COMPLETED",
      "FINAL_APPROVED",
      "FINAL_DONE"
    ],
    alerts: ["EXTERNAL_REJECTED", "INTERNAL_REJECTED"]
  },
  finished: { name: "Anúncios Finalizados", indexes: ["DONE"] }
};

const state: CampaignStateObj = {
  active: {},
  list: {},
  campaigns: [],
  selectedFormats: [] as ProductFormat[],
  suggestedProducts: [],
  availableProducts: [],
  selectedProductIds: [],
  ignoredProductIds: [],
  minInvestment: 0,
  mediaPlanShowResume: false,
  productsCount: 0,
  statusGroup,
  statusList,
  genderList,
  locationsList: [],
  broadcasters: [],
  marketSegmentList: [],
  locationSearchResults: [],
  locationsBroadcasterNames: [],
  statusGroupEditable,
  ObjetivesList,
  daysList,
  formatsList,
  timesList,
  durationsList,
  socialClassList,
  campaignSteps
};

export default { ...state };
